const MENU_OPEN_ICON = 'fa-times';
const MENU_CLOSE_ICON = 'fa-bars';

const attachListenersToNavbar = () => {
    const menuSwitch = document.querySelector(
        '.mobile-menu-switch',
    ) as HTMLButtonElement;
    const menuSwitchIcon = menuSwitch.querySelector('span') as HTMLSpanElement;
    const menu = document.querySelector('.menu-list') as HTMLUListElement;
    const userDropdown = document.querySelector(
        '.dropdown-wrapper',
    ) as HTMLDivElement;

    menuSwitch.addEventListener('click', () => {
        menu.classList.toggle('active');
        const isMenuOpen = menuSwitchIcon.classList.contains(MENU_CLOSE_ICON);
        menuSwitchIcon.classList.remove(
            isMenuOpen ? MENU_CLOSE_ICON : MENU_OPEN_ICON,
        );
        menuSwitchIcon.classList.add(
            isMenuOpen ? MENU_OPEN_ICON : MENU_CLOSE_ICON,
        );
    });

    userDropdown.addEventListener('click', () => {
        menu.classList.remove('active');
        menuSwitchIcon.classList.remove(MENU_OPEN_ICON);
        menuSwitchIcon.classList.add(MENU_CLOSE_ICON);
    });
};

const elementExists = (el) => typeof el !== 'undefined' && el != null;

const isNewNavbar = elementExists(document.querySelector('.sf-navbar'));

if (isNewNavbar) attachListenersToNavbar();
